/* Learn hero clips (Sept 2026). Same behaviour as the homepage card loops in der-home.js:
   a muted 8 s MP4 is only downloaded and played once the hero is near the viewport, never
   under prefers-reduced-motion, and it fades in over the still only once it is really playing. */
(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function init(root) {
    var vids = (root || document).querySelectorAll('video[data-dl-lazy-video]');
    if (!vids.length || reduce) return;
    function play(v) {
      if (v.dataset.dlStarted) return; v.dataset.dlStarted = '1';
      v.addEventListener('playing', function () { v.classList.add('is-playing'); }, { once: true });
      v.preload = 'auto'; var p = v.play(); if (p && p.catch) p.catch(function () {});
    }
    if (!('IntersectionObserver' in window)) { vids.forEach(play); return; }
    var io = new IntersectionObserver(function (en) { en.forEach(function (e) { if (e.isIntersecting) { play(e.target); io.unobserve(e.target); } }); }, { rootMargin: '300px 0px' });
    vids.forEach(function (v) { io.observe(v); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); }); else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
